import { render, staticRenderFns } from "./PaymentProvider.vue?vue&type=template&id=3445dd14"
import script from "./PaymentProvider.vue?vue&type=script&lang=js"
export * from "./PaymentProvider.vue?vue&type=script&lang=js"
import style0 from "./PaymentProvider.vue?vue&type=style&index=0&id=3445dd14&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports